import styled from "styled-components";
import { MapContainer } from "react-leaflet";

export const MapWrapper = styled(MapContainer)`
  width: 100%;
  height: 80vh;
`;
